export enum videoSortType {
  last = "time.upload:-1",
  recommend = "recommend:-1"
}
